export enum B2cClient{
    'LUX'= 'LUX',
    'SAMSUNG_UK'='SAMSUNG_UK',
    'SAMSUNG_IT'='SAMSUNG_IT',
    'SAMSUNG_FR'='SAMSUNG_FR',
    'SAMSUNG_DE'='SAMSUNG_DE',
    'PYB' = 'PYB',
    'SAMSUNG'='SAMSUNG'
}